import { HolidayEvent, HolidayEvents } from '@nextforce/api'
import { Icon, makeStyles, Text, useTheme } from '@rneui/themed'
import { onlineManager } from '@tanstack/react-query'
import { font } from 'app/theme'
import { View } from 'react-native'
import { Card } from 'shared/components/card'
import { PressableOpacity } from 'shared/components/pressable_opacity'
import { useUser } from 'users/queries/detail'

interface Props {
  event: HolidayEvents
  onEditHolidayEvent: (holidayEvent: HolidayEvent) => void
}

export function HolidayEventView({ event, onEditHolidayEvent }: Props) {
  if (!event.holidayEvents.length) {
    return null
  }

  return (
    <View>{getHolidayEventViews(event.holidayEvents, onEditHolidayEvent)}</View>
  )
}

function getHolidayEventViews(
  events: HolidayEvent[],
  onEditHolidayEvent: (holidayEvent: HolidayEvent) => void
) {
  return events.map((holidayEvent, index) => (
    <HolidayEventCard
      holidayEvent={holidayEvent}
      key={String(index)}
      onEditHolidayEvent={onEditHolidayEvent}
    />
  ))
}

function HolidayEventCard({
  holidayEvent,
  onEditHolidayEvent,
}: {
  holidayEvent: HolidayEvent
  onEditHolidayEvent: (holidayEvent: HolidayEvent) => void
}) {
  const { theme } = useTheme()
  const styles = useStyles()
  const { data: user } = useUser()
  const canEditHolidayEvent = user?.permissions?.canEditHolidayEvents

  return (
    <Card style={styles.card}>
      <View style={{ flexDirection: 'row' }}>
        <Icon
          type="font-awesome-5"
          name="gifts"
          size={20}
          color={theme.colors?.primary}
          containerStyle={styles.iconContainerStyle}
          solid
        />
        <Text style={styles.name}>{`${holidayEvent.name}`}</Text>
        {canEditHolidayEvent ? (
          <PressableOpacity
            disabled={!onlineManager.isOnline()}
            onPress={() => {
              onEditHolidayEvent(holidayEvent)
            }}
          >
            <Text style={styles.text}>Edit</Text>
          </PressableOpacity>
        ) : null}
      </View>
    </Card>
  )
}

export const HOLIDAY_EVENT_HEIGHT = 65

export const HOLIDAY_TOP_MARGIN = 5

const useStyles = makeStyles(theme => ({
  card: {
    height: HOLIDAY_EVENT_HEIGHT,
    alignItems: 'center',
    marginTop: HOLIDAY_TOP_MARGIN,
  },
  name: {
    flex: 1,
    fontSize: 18,
    fontFamily: font.bold,
    color: theme.colors?.black,
    textAlignVertical: 'center',
  },
  iconContainerStyle: {
    paddingRight: 5,
    marginRight: 5,
  },
  text: {
    padding: 2,
    margin: 2,
    color: '#353B4A',
  },
}))
